import React, { createContext } from "react";

import { InitialConfigContext } from "custom-types/FinderPage";
import { RetailType } from "custom-types/Store";

export const finderConfigContext = {
  FAQData: { data: {} },
  farAwayThreshold: 25,
  finderRoute: "/dispensaries",
  isLocationPage: false,
  retailType: "dispensary" as RetailType,
  storeRoute: "/dispensary-info/",
  title: "Dispensaries",
};

const ConfigContext = createContext<InitialConfigContext>(finderConfigContext);

export const ConfigProvider = ({
  children,
  data,
}: {
  children: React.ReactNode;
  data: InitialConfigContext;
}) => <ConfigContext.Provider value={data}>{children}</ConfigContext.Provider>;

export default ConfigContext;
